import { OrdersHistoryPresenter } from './../../orders-history/orders-history.presenter';
import { Component, Inject, forwardRef, ViewEncapsulation } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-order-wks-status',
  templateUrl: './order-wks-status.component.html',
  encapsulation: ViewEncapsulation.None
})
export class OrderWksStatusComponent implements ICellEditorAngularComp {

  agParam: any;
  statusClass: string;
  private historyOrderPresenter: OrdersHistoryPresenter = new OrdersHistoryPresenter();

  agInit(params): void {
    this.agParam = params;
    this.statusClass = this.historyOrderPresenter.getStatusClass(this.agParam.data.stateCode);
  }

  getValue() {
    throw new Error("Method not implemented.");
  }
  isPopup?(): boolean {
    throw new Error("Method not implemented.");
  }
  isCancelBeforeStart?(): boolean {
    throw new Error("Method not implemented.");
  }
  isCancelAfterEnd?(): boolean {
    throw new Error("Method not implemented.");
  }
  focusIn?(): void {
    throw new Error("Method not implemented.");
  }
  focusOut?(): void {
    throw new Error("Method not implemented.");
  }
  afterGuiAttached?(params?): void {
    throw new Error("Method not implemented.");
  }

}
